import { c as _c } from "react/compiler-runtime";
import { Logo } from '@repo/design-system/components/ds/logo';
import { css } from '@repo/panda/css';
export function GameMapLoading() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = css({
      position: "absolute",
      top: "none",
      left: "none",
      backgroundColor: "wemod.elevated.100",
      width: "full",
      height: "full",
      zIndex: 3,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const loadingBackgroundStyles = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = css({
      animationName: "bounce",
      animationIterationCount: "infinite",
      animationDuration: "[3s]",
      animationDelay: "[1s]",
      animationDirection: "alternate",
      animationTimingFunction: "in-out",
      color: "brand.primary",
      width: "[100px]"
    });
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const logoStyles = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={loadingBackgroundStyles}><div className={logoStyles}><Logo variant="icon" aria-label="Wand logo" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}